<script lang="ts" setup>
import { PropType, computed } from 'vue'

import { StandingsRundownRow } from '@/store/public/leagues.types'
import { formatFloat, formatValue } from '@/utils/format'

const props = defineProps({
  rows: {
    type: Array as PropType<StandingsRundownRow[]>,
    required: true,
  },
})

const hasHandicap = computed<boolean>(
  () =>
    props.rows.filter((r) => r.total_raw_score !== r.total_score).length > 0,
)
</script>

<template>
  <div class="table-container">
    <table class="table">
      <thead>
        <tr>
          <th class="fit-content"></th>
          <th>{{ $t('leagues.labels.bowler') }}</th>
          <th>{{ $t('leagues.labels.team') }}</th>
          <th class="align-center">{{ $t('leagues.labels.total') }}</th>
          <th class="align-center">{{ $t('leagues.labels.series-played') }}</th>
          <th class="align-center">{{ $t('leagues.labels.average') }}</th>
          <th v-if="hasHandicap" class="align-center">
            {{ $t('leagues.labels.cleanAverage') }}
          </th>
          <th class="align-center">{{ $t('leagues.labels.best') }}</th>
          <th class="align-center">{{ $t('leagues.labels.bonus') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(row, i) in rows" :key="`rundown-row-${i}`">
          <td class="align-right fit-content">{{ i + 1 }}.</td>
          <td>{{ formatValue(row.bowler_full_name) }}</td>
          <td>{{ formatValue(row.team_name) }}</td>
          <td class="align-center">
            {{ formatFloat(row.total_score, 0) }}
          </td>
          <td class="align-center">{{ formatFloat(row.game_count, 0) }}</td>
          <td v-if="hasHandicap" class="align-center">
            {{ formatFloat(row.average_score, 2) }}
          </td>
          <td class="align-center">
            {{ formatFloat(row.average_raw_score, 2) }}
          </td>
          <td class="align-center">{{ formatFloat(row.best_raw_score, 0) }}</td>
          <td class="align-center">
            {{ formatFloat(row.total_personal_bonuses, 0) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
